import React from 'react';
import { InputField } from 'vindi-ds-components';

function CustomerNeighborhoodField() {
  return (
    <InputField
      placeholder='Digite aqui seu bairro'
      label='Bairro'
      name='neighborhood'
    />
  );
}

export default CustomerNeighborhoodField;
